/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#helpers)
 */
export const serverApiPrefix = '/x-api'
export function getEndpoint(operation, operationName) {
  return serverApiPrefix + '/' + operation + '/' + operationName
}